module.exports = __webpack_public_path__ + "static/media/image_11.41515bae.jpg";